import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeftSharp";
import { Box, LinearProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { CloseIcon } from "assets/svgs";
import { MainButton } from "components";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store/storeHooks";
import { CloseBtn } from "styles/global.style";
import { FormDrawerStyled } from "./formDrawer.styled";
import { setOpenDrawer } from "./formdrawer.slice";

interface IFormDrawer {
  isTop?: boolean;
  isFullWidth?: boolean;
  children: React.ReactNode;
  formItemTitle?: string; //? don't write : "Yangi role..." just write "Role"
  FORM_ID?: string; //? to connect form and submit button
  onClose?: any; //? to reset form
  customTitle?: React.ReactNode;
  isEditing?: boolean;
  isLoading?: boolean;
  actionBtns?: boolean;
  createButtonTitle?: string;
  deleteBtnTitle?: string;
  // createButtonColor?: TButtonColors;
  onClickSubmit?: () => void;
  onCloseClick?: () => void;
  cancelButtonTitle?: string;
  deleteFn?: () => void;
  // cancelButtonColor?: TButtonColors;
  className?: string;
}

const FormDrawer: React.FC<IFormDrawer> = ({
  isFullWidth,
  children,
  formItemTitle = "FORMDRAWER.ELEMENT",
  FORM_ID,
  onClose,
  isEditing,
  isTop = false,
  isLoading,
  customTitle,
  actionBtns = true,
  createButtonTitle = "FORMDRAWER.SAVE",
  cancelButtonTitle = "FORMDRAWER.BACK",
  onClickSubmit,
  onCloseClick,
  deleteBtnTitle,
  deleteFn,
  className,
}) => {
  const { t } = useTranslation();
  const { isOpen, disableSubmitButton } = useAppSelector(
    (store) => store.formDrawerState
  );
  const dis = useAppDispatch();

  useEffect(() => {
    return () => {
      dis(setOpenDrawer(false)); // @bug this-may-cause-to-bug
    };
  }, []);

  return (
    <FormDrawerStyled
      className={className}
      open={isOpen}
      onClose={() => {
        onClose?.();
        dis(setOpenDrawer(false));
      }}
      // onOpen={() => dis(setOpenDrawer(true))}
      anchor="right"
      // disableAutoFocus
      // disableEnforceFocus
      // disableRestoreFocus
      // disablePortal
      BackdropProps={{
        sx: {
          backdropFilter: "blur(2px)",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: isFullWidth ? undefined : "2% 0 0 2%",
          // backgroundColor: "red",
        },
      }}
    >
      <div
        className={
          isFullWidth || !actionBtns
            ? "form_drawer_container active"
            : "form_drawer_container"
        }
      >
        <div className="form_drawer_header">
          <Grid container className="form_drawer_header_content">
            {isTop && isFullWidth && (
              <Grid item md={1}>
                <IconButton
                  onClick={() => {
                    onClose?.();
                    dis(setOpenDrawer(false));
                  }}
                  color="primary"
                >
                  <KeyboardArrowLeftIcon />
                </IconButton>
              </Grid>
            )}
            <Grid item md={8}>
              <h2 className="title">
                {customTitle ||
                  (isEditing
                    ? `${t(formItemTitle)}`
                    : `${t("FORMDRAWER.NEW")} ${t(formItemTitle)}`)}
              </h2>
            </Grid>

            {isFullWidth && (
              <Grid
                item
                md={3}
                display="flex"
                justifyContent="end"
                alignItems="center"
              >
                <MainButton
                  form={FORM_ID}
                  type="submit"
                  variant="contained"
                  title={t(createButtonTitle)}
                  style={{ width: "140px" }}
                />
              </Grid>
            )}

            {!isFullWidth && (
              <Grid item md={2} display="flex" justifyContent="flex-end">
                <CloseBtn
                  onClick={() => {
                    onClose?.();
                    dis(setOpenDrawer(false));
                  }}
                >
                  <CloseIcon />
                </CloseBtn>
              </Grid>
            )}
          </Grid>
        </div>

        {isLoading && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        )}

        <div
          className={
            !actionBtns ? "form_drawer_content active" : "form_drawer_content"
          }
        >
          <Grid item container md={12}>
            {children}
          </Grid>
        </div>
      </div>

      {!isTop && actionBtns && (
        <div className="form_drawer_bottom">
          <Grid
            item
            md={12}
            container
            spacing={2}
            className="form_drawer_bottom_content"
          >
            <Grid item md={deleteBtnTitle && isEditing ? 4 : 6}>
              <MainButton
                onClick={() => {
                  onClose?.();
                  dis(setOpenDrawer(false));
                  onCloseClick?.();
                }}
                title={t(cancelButtonTitle)}
                style={{ backgroundColor: "#f5f5f5" }}
                className="cancel"
              />
            </Grid>
            {typeof deleteFn === "function" && isEditing && (
              <Grid item md={4}>
                <MainButton
                  onClick={() => {
                    deleteFn?.();
                  }}
                  title={deleteBtnTitle}
                  className="deleteBtn"
                />
              </Grid>
            )}
            <Grid
              item
              md={deleteBtnTitle && isEditing ? 4 : 6}
              display="flex"
              justifyContent="end"
            >
              <MainButton
                form={FORM_ID}
                type="submit"
                variant="contained"
                onClick={() => {
                  onClickSubmit?.();
                }}
                title={t(createButtonTitle)}
                // style={{ width: "140px" }}
                disabled={disableSubmitButton}
                loader={disableSubmitButton}
              />
            </Grid>
          </Grid>
        </div>
      )}
    </FormDrawerStyled>
  );
};

export default FormDrawer;
